<template>
  <!--  main div  -->
  <div
    class="d-flex flex-column mt-2 justify-content-start"
    style="height: 100%"
  >
    <v-row justify="center" style="height: 100%">
      <v-col cols="12" sm="12" style="height: 100%">
        <x-card :home="true" class="d-flex flex-column flex" style="height: 100%">
          <v-card-title class="py-1">Change programme</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 100%">
            <x-tabs v-model="tab" class="flex-grow-1" style="height: 100%" show-arrows>
              <template v-slot:tab>
                <x-tab key="change">Apply</x-tab>
                <x-tab key="history">History</x-tab>
              </template>
              <template v-slot:items>
                <x-tab-items v-model="tab" style="height: 100%">
                  <v-tab-item key="change">
                    <v-divider></v-divider>
                    <div v-if="canChangeCourse">
                      <div v-if="currentPayment != null && currentPayment.cleared">
                        <v-card-text
                            class="d-flex flex-column"
                            v-if="pendingChangeOfProgramme == null"
                        >
                          <v-alert dense border="left" type="warning">
                            Note: Make sure you meet the requirement for the target
                            department before proceeding
                          </v-alert>
                          <div class="d-flex flex-row">
                            <div class="flex-grow-1">
                              <v-card
                                  rounded
                                  elevation="1"
                                  width="260"
                                  class="pa-2 mx-auto align-content-center"
                              >
                                <v-img
                                    :src="image"
                                    width="250px"
                                    aspect-ratio="1"
                                ></v-img>
                              </v-card>
                            </div>
                            <div class="flex-grow-1 mr-8">
                              <v-form v-model="valid">
                                <v-text-field
                                    :readonly="true"
                                    outlined
                                    :value="getUser.programme.name"
                                    label="Current programme"
                                ></v-text-field>
                                <v-select
                                    label="Target programme"
                                    :rules="rules"
                                    required
                                    outlined
                                    v-model="targetProgram"
                                    return-object
                                    :items="listTargetPrograms"
                                    item-text="name"
                                ></v-select>
                                <v-textarea
                                    :rules="rules"
                                    required
                                    outlined
                                    label="Reason for leaving..."
                                    v-model="programreason"
                                ></v-textarea>
                              </v-form>
                              <v-btn
                                  depressed
                                  color="primary"
                                  elevation="2"
                                  width="100%"
                                  @click="process"
                                  :disabled="!valid"
                              >
                                Submit
                              </v-btn>
                            </div>
                          </div>
                        </v-card-text>
                        <v-card-text class="pa-20 mt-15" v-else>
                          <div class="d-flex justify-center">
                            <v-alert x-large outlined depressed type="info" dark
                            >You already have a pending application</v-alert
                            >
                          </div>
                        </v-card-text>
                      </div>
                      <!-- if pending payment -->
                      <div class="d-flex justify-center mt-10" v-else>
                        <div class="mx-auto">
                          <v-alert type="info" outlined>
                            Payment of {{getAmount()}} is required
                          </v-alert>
                          <v-btn
                              color="primary"
                              @click="initializePayment"
                              depressed
                              width="100%"
                              class="mt-4">Proceed with payment
                          </v-btn
                          >
                        </div>
                      </div>
                    </div>
                    <div clas="d-flex justify-center" v-else>
                      <v-card-text>
                        <v-alert type="warning">
                          You can not change your programme at this point
                        </v-alert>
                      </v-card-text>
                    </div>
                  </v-tab-item>

                  <v-tab-item key="history">
                    <v-divider></v-divider>
                    <change-of-programme-history :items="records"></change-of-programme-history>
                  </v-tab-item>
                </x-tab-items>
              </template>
            </x-tabs>
          </v-card-text>
        </x-card>
      </v-col>
    </v-row>

    <loading-dialog :show="loading"></loading-dialog>
    <message-box
      :show="messageShow"
      :message="message"
      :type="messageType"
      v-on:close-message="messageShow = !messageShow"
    ></message-box>
  </div>
</template>


<script>
import LoginUtil from "@/login/LoginUtil";
import Defaults from "@/shared/Defaults";
import LoadingDialog from "@ui/components/LoadingDialog";
import MessageBox from "@ui/components/MessageBox";
import ErrorResolver from "@/shared/ErrorResolver";
import Api from "@/main/api";
import { mapGetters } from "vuex";
import ValidationRules from "@/shared/ValidationRules";
import StudentStatus from "@/shared/StudentStatus";
import { PaymentGateway } from "@/shared/PaymentGateway";
import GateWays from "@/shared/GateWays";
import Links from "@/shared/constants/Links";
import NumberUtils from "@/shared/NumberUtils";
import ChangeOfProgrammeHistory from "@/components/change_programme/ChangeOfProgrammeHistory";
import XTabs from "@ui/components/XTabs.vue";
import XTabItems from "@ui/components/XTabItems.vue";
import XTab from "@ui/components/XTab.vue";
import XCard from "@ui/components/XCard.vue";

export default {
  name: "ChangeProgram",
  components: {
    XCard,
    XTab,
    XTabItems,
    XTabs,
    ChangeOfProgrammeHistory,
    LoadingDialog,
    MessageBox,
  },
  data: () => ({
    items: [],
    rules: ValidationRules.textRules,
    image: "",
    loading: false,
    messageType: "",
    message: "",
    messageShow: false,
    targetProgram: null,
    listTargetPrograms: [],
    programreason: null,
    valid: true,
    payment: null,
    paymentGateway: null,
    paymentConfig: null,
    pendingChangeOfProgramme: null,
    currentPayment: null,
    tab: null,
    records: []
  }),

  //FTCMP0002
  methods: {
    changeProgram() {
      this.loading = true;
      Api.programmeChange
        .applyApplicant({
          studentId: this.getUser.userId,
          reason: this.programreason,
          targetProgrammeId: this.targetProgram.id,
        })
        .then(() => {
          this.message = `You've successfully applied for change of programme`;
          this.messageType = "success";
          this.messageShow = true;

          let r = function () {
            window.location.reload();
          };

          setTimeout(r, 2000);
        })
        .catch((err) => {
          console.log(err);
          ErrorResolver.checkErrors(this, err);
          this.loading = false;
        });
    },

    loadPending() {
      if (this.getUser == null) return;

      this.loading = true;
      Api.programmeChange
        .getPendingForApplicant(this.getUser.userId)
        .then((res) => {
          this.pendingChangeOfProgramme = res.data;
        })
        .catch((err) => ErrorResolver.checkErrors(this, err))
        .finally(() => (this.loading = false));
    },

    loadProgrammes() {
      Api.programmes
        .allForProgrammeType(this.getUser.programme.programmeType.id)
        .then((res) => {
          if (this.listTargetPrograms !== null) {
            this.listTargetPrograms = res.data;
          }
        });
    },

    process() {
      this.changeProgram();
    },

    initializePayment() {
      // initialize and get invoice
      this.loading = true;
      Api.programmeChange
        .initializeApplicantChangeOfProgramme({
          userId: this.getUser.userId,
        })
        .then((res) => {
          this.payment = res.data;
          // show alert and make payment
          this.message = "Initialized";
          this.messageType = "success";
          this.messageShow = true;
          this.makePayment();
        })
        .catch((err) => ErrorResolver.checkErrors(this, err))
        .finally(() => (this.loading = false));
    },

    getAmount(){
      if (this.getUser == null)
        return "00.0";
      return NumberUtils.format(this.getUser.admission.applicationType.changeProgrammeFee)
    },

    makePayment() {
      if (this.payment != null) {
        if (this.paymentConfig.inline) {
          this.paymentGateway.makePayment(
            {
              email: this.getUser.email,
              amount: this.getUser.admission.applicationType.changeProgrammeFee,
              currency: "NGN",
              invoice: this.payment.transactionId,
              paymentId: this.payment.id,
            },
            () => {}
          );
        } else {
          // payment should not be done inline
          // open windwo for payment
          this.loading = true;
          window.location.href = this.payment.paymentLink;
        }
      }
    },

    getCurrentPayment() {
      if (this.getUser != null) {
        this.loading = true;
        Api.programmeChange
          .getCurrentPayment(this.getUser.userId)
          .then((res) => (this.currentPayment = res.data))
          .catch((err) => ErrorResolver.checkErrors(this, err))
          .finally(() => (this.loading = false));
      }
    },

    loadRecords(){
      if(this.getUser != null){
        this.loading = true
        Api.programmeChange.getAllForApplicant(this.getUser.userId)
            .then(res => {
              this.records = res.data
            }).catch(err => ErrorResolver.checkErrors(this, err))
            .finally(() => this.loading = false)
      }
    }
  },

  computed: {
    ...mapGetters(["getUser"]),
    showPending: function () {
      return (
        this.getUser == null ||
        this.getUser.studentStatus === StudentStatus.PROGRAMME_CHANGE.text
      );
    },

    canChangeCourse: function () {
      return (
          this.getUser != null && this.getUser.admission.applicationType.changeProgrammesStatus.includes(this.getUser.studentStatus) &&
          !this.getUser.migrated
      );
    },
  },

  watch: {
    getUser: function (val) {
      if (val) {
        this.image =
          Defaults.api + "/profile-picture/fetch?user=" + this.getUser.userId;
        this.loadProgrammes();
        this.loadPending();
        this.getCurrentPayment();
      }
    },
  },

  mounted() {
    // initialize gateway
    this.$nextTick(() => {
      this.paymentGateway = new PaymentGateway(
        GateWays.PAYSTACK,
        this,
        Links.applicants.verifyApplicationFeeTransaction
      );
      Api.paymentPlatforms
        .getActive()
        .then((res) => {
          if (this.paymentGateway != null) {
            // set config
            this.paymentConfig = res.data;
            // if inline, initialize
            if (res.data.inline)
              this.paymentGateway.initializeGateway(res.data);
          } else {
            this.message = "No payment settings found";
            this.messageType = "error";
            this.messageShow = true;
          }
        })
        .catch((err) => ErrorResolver.checkErrors(this, err));
    });
  },

  created() {
    if (
      !LoginUtil.getAccessToken() &&
      !LoginUtil.getRefreshToken()
    ) {
      // not logged in
      this.$router.push("/");
      return;
    }

    if (this.getUser != null) {
      this.loadProgrammes();
      this.image =
        Defaults.api + "/profile-picture/fetch?user=" + this.getUser.userId;
    }

    this.loadPending();
    this.getCurrentPayment();
    this.loadRecords()
  },
};
</script>
